'use client'

import { PropsWithChildren, useState } from 'react'

import { QueryClient, QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query'

export function QueryClientProvider({ children }: PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
          },
        },
      })
  )

  return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>
}
